export const surveyTypes = {
  COMPLETED: 'completed',
  IN_PROGRESS: 'in_progress',
  OPEN: 'open',
  CLOSED: 'closed',
  REPORT_READY: 'report_ready',
  SURVEY_ENDED: 'survey_ended',
};
